<template>
    <div class="introBlock">
        <div class="container">
            <!--todo 可參考附近店家跑馬燈(第一階段先沒有)-->
            <div class="marquee" v-if="false">
                <div class="loudly"/>
                <div class="text">
                    <div class="marquees">
                        <span v-for="s in 10" :key="s" @click="$router.push({name: 'MarketplaceArticle'})">
                            跑馬燈
                        </span>
                    </div>
                </div>
            </div>
            <!--todo 商圈資訊店家數-->
            <div class="marketplace-item" :style="{backgroundImage: 'url(' + shoppingAreaInfo.coverImageUrl + ')' }">
                <div class="content">
                    <div class="track" v-if="false"/>
                    <el-image
                            class="logo"
                            :src="shoppingAreaInfo.logoImageUrl"
                            fit="cover"/>
                    <div class="small mt-3">{{showName}}</div>
                    <div class="small">店家數：{{shoppingAreaInfo.merchantCount}}</div>
                </div>
            </div>

            <!-- todo FB、IG、YT等連結 -->
            <links :socialWebsites="websites" :socialWebsitesStatus="mediaLinks.websiteStatus" :iconType="iconType" v-if="mediaLinks.websiteStatus"/>
            <el-divider class="mb-3"/>
        </div>

        <template v-if="offersList.length > 0">
            <category-header :to="{name: 'TicketList', query:{p: ticketListParameter}}" title="搶券熱區" class="mt-4"/>
            <Ticket :list="offersList" :dataToken="ticketDataToken" :PreviewNum="9"/>
            <el-divider class="mb-3"/>
        </template>

        <category-header title="地址" class="mb-2"/>
        <div class="container text-content mb-4">{{showAddress}}</div>

        <category-header title="關於我們" class="mb-2" v-show="isShowAbout(shoppingAreaInfo)"/>
        <div ref="htmlAboutContainer" class="container text-content mb-3" v-show="isShowAbout(shoppingAreaInfo)" v-html="shoppingAreaInfo.about"/>

        <!--todo 輪播-->
        <div class="container" v-show="isShowBanner(bannerList)">
            <el-divider class="m-0"/>
            <!--橫圖加上樣式 isHorizontal -->
            <banner :list="bannerList" class="mt-4 mb-4 banner" :class="{'isHorizontal':isHorizontal}"/>
        </div>

        <!--todo 一張單圖-->
        <div class="container mt-4 mb-4" v-show="isShowGraphImage(shoppingAreaInfo)">
            <el-divider class="m-0 mb-4"/>
            <img :src="shoppingAreaInfo.graphImageUrl" class="radius-pic">
        </div>

        <!--todo YT嵌入-->
        <div class="container mt-4 mb-4" v-show="isShowVideo(videoUrl)">
            <el-divider/>
            <div class="video-container mt-4">
                <iframe id="intro-video-frame" width="560" height="315" src="" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"/>
            </div>
        </div>

        <!--todo 店家推薦(第一階段先沒有)-->
        <category-content v-if="false">
            <category-header title="店家推薦"/>
            <item-grid height="136px">
                <store-item :to="{name: 'StoreInfo'}" :list="myAddStoreList"/>
            </item-grid>
        </category-content>

        <!--todo 必買好物(第一階段先沒有)-->
        <category-content v-if="false">
            <category-header title="必買好物"/>
            <item-grid>
                <GoodsItem v-for="s in 4" :key="s"/>
            </item-grid>
        </category-content>

        <loading
            :active.sync=isLoading
            :can-cancel="false"
            :is-full-page="true">
        </loading>
        <toast/>
    </div>
</template>

<script>
    import CategoryHeader from '@/components/category/Header'
    import CategoryContent from "../../../components/category/Content";
    import ItemGrid from "../../../components/category/ItemGrid";
    import Banner from "../../../components/BannerSlider";
    import StoreItem from "../../../components/category/StoreItem";
    import GoodsItem from "./GoodsItem";
    import Links from "./Links";
    import * as constDefine from '@/store/constDefine'
    import Toast from "@/components/Toast"
    import Form from "@/util/form";
    import Ticket from "@/views/complex/components/SliderTicket.vue";

    export default {
        name: "IntroInfo",
        components: {
            Ticket,
            CategoryContent,
            CategoryHeader,
            ItemGrid,
            Banner,
            StoreItem,
            GoodsItem,
            Links,
            Toast,
        },
        props: {
            // list: { type:Array, default: Array.of([]) },  // list = [url:string, imgUrl:string]
            outerAreaInfo: { default: undefined },  // 外層傳來的 shoppingAreaInfo
        },
        watch: {
            //注意，當要監聽不是數值型的物件，而是參考或陣列的話，會監聽失敗
            // 因爲 watch並無法知道物件內某個元素的變化，也無法知道陣列內某個元素的變化

            //監聽，因爲包成元件的物件只能用 props來傳遞參數，在元件內部監聽參數是否有變化來抓資料
            // shopAreaId: function() {
            //     this.getShoppingAreaInfo(this.shopAreaId);
            // }
            //監聽，等到資料有變動再開始動作
            outerAreaInfo: function() {
                let self = this;
                if (this.outerAreaInfo !== undefined) {
                    self.shoppingAreaInfo = self.outerAreaInfo;
                    self.offersList = self.shoppingAreaInfo?.offersList || []

                    let obj = {
                        objectType: constDefine.MerchantType.ShoppingArea,
                        objectId: self.shoppingAreaInfo.id,
                    }
                    self.ticketListParameter = self.$crypto.encryptObject(obj);
                    self.ticketDataToken = self.$crypto.objectToURIComponent(obj)

                    self.processScreenData();
                    if (self.isContainerRendered) {
                        self.handleAboutUs();
                    }
                }
            },

            isContainerRendered: function () {
                if (this.isContainerRendered) {
                    if (this.isDataProcessed) {
                        this.handleAboutUs();
                    }
                }
            }
        },
        computed: {
            isHorizontal: function () {
                if (this.$public.notNull(this.shoppingAreaInfo)) {
                    return this.shoppingAreaInfo.carouselType === 2;
                } else {
                    return false;
                }
            }
        },
        data() {
            return {

                shoppingAreaInfo: {},       //商圈資料
                videoUrl: '',           //影片連結
                showName: '',           //顯示用商圈名稱
                showCity: '',           //顯示用城市名稱
                showAddress: '',        //顯示用地址
                //輪播
                bannerList: [],
                //店家推薦
                myAddStoreList: [],
                //搶券熱區
                offersList: [],
                ticketListParameter: "",
                ticketDataToken: "",
                //店家網頁連結
                mediaLinks: {
                    linkFb: '',
                    linkLine: '',
                    linkIg: '',
                    linkYoutube: '',
                    linkTwitter: '',
                    linkWebsite: '',
                    linkUbereats: '',
                    linkFoodpanda: '',
                    linkTiktok: '',
                    websiteStatus: false,
                },
                websites: '',
                iconType: '', //社群連結Icon樣式
                imgUrl:require('../../../assets/images/img.png'),

                isLoading: false,
                lng: 0,
                lat: 0,
                pageSize: 10,
                currentPage: 0,

                shopStoreList : [],         //商店列表
                shopVendorList: [],         //攤販列表

                //加載資料與恢復頁面狀態相關
                // setupListData: false,       //是否有載入過初始資料?
                // infiniteInfinite: 0,
                // infiniteLoadingState: '',
                scrollTo: '',
                offsetHeight: 0,

                isContainerRendered: false,
                isDataProcessed: false,

            }
        },
        created() {

        },
        mounted() {
            this.isContainerRendered = true;
        },
        methods: {

            /** 處理一些顯示用的資料 */
            processScreenData: function () {
                // let pData = this.pageData;
                let self = this;
                return new Promise(function(resolve, reject) {
                    //夜市商圈列表
                    if (self.$public.notNull(self.shoppingAreaInfo)){

                        let typeName = '';

                        //商圈用，主辦方類型 0:其他 1:串門子 2:商圈 3:夜市 4:市集 5:店家
                        switch (self.shoppingAreaInfo.shoppingType) {
                            case constDefine.ShopAreaType.Other:
                                typeName = '其他';
                                break;
                            case constDefine.ShopAreaType.Oin:
                                typeName = '串門子';
                                break;
                            case constDefine.ShopAreaType.ShoppingArea:
                                typeName = '商圈';
                                break;
                            case constDefine.ShopAreaType.NightMarket:
                                typeName = '夜市';
                                break;
                            case constDefine.ShopAreaType.Market:
                                typeName = '市集';
                                break;
                            case constDefine.ShopAreaType.Store:
                                typeName = '店家';
                                break;
                        }

                        //顯示用的商圈地點
                        self.showName = self.shoppingAreaInfo.showCity +self.shoppingAreaInfo.showTownship;
                        //顯示用的城市名稱
                        self.showCity = `${self.shoppingAreaInfo.showCity}/${typeName}`;
                        //顯示用的地址
                        self.showAddress = self.shoppingAreaInfo.showCity +self.shoppingAreaInfo.showTownship +self.shoppingAreaInfo.showAddress


                        //輪播圖轉成首頁形式
                        if (self.$public.notNull(self.shoppingAreaInfo.photoImageUrlJsonStr) &&
                            self.shoppingAreaInfo.photoImageUrlJsonStr !== '') {

                            let photoList = self.shoppingAreaInfo.photoImageUrlJsonStr;
                            if (self.$public.notNull(photoList)) {
                                let bannerList = [];
                                photoList.forEach(
                                    (item) => {
                                        bannerList.push( self.transToHomeBanner(item)) ;
                                    }
                                )

                                self.bannerList = bannerList;
                            }
                        }

                        //處理影片
                        if (self.$public.notNull(self.shoppingAreaInfo.mediaUrl) &&
                            self.shoppingAreaInfo.mediaUrl !== '') {
                            self.changeVideoUrl(self.shoppingAreaInfo.mediaUrl);
                        }

                        self.mediaLinks.websiteStatus = self.shoppingAreaInfo.websiteStatus===1?true:self.shoppingAreaInfo.websiteStatus===true?true:false;
                        //轉換店家網頁連結
                        if (self.$public.notNull(self.shoppingAreaInfo.websites) &&
                            self.shoppingAreaInfo.websites.length > 0) {
                            self.websites = JSON.stringify(self.shoppingAreaInfo.websites);

                            self.shoppingAreaInfo.websites.forEach(
                                (item) => {
                                    switch (item.type) {
                                        case constDefine.SITE_TYPE_FB:
                                            self.mediaLinks.linkFb = item.url;
                                            break;
                                        case constDefine.SITE_TYPE_LINE:
                                            self.mediaLinks.linkLine = item.url;
                                            break;
                                        case constDefine.SITE_TYPE_IG:
                                            self.mediaLinks.linkIg = item.url;
                                            break;
                                        case constDefine.SITE_TYPE_YOUTUBE:
                                            self.mediaLinks.linkYoutube = item.url;
                                            break;
                                        case constDefine.SITE_TYPE_TWITTER:
                                            self.mediaLinks.linkTwitter = item.url;
                                            break;
                                        case constDefine.SITE_TYPE_WEBSITE:
                                            self.mediaLinks.linkWebsite = item.url;
                                            break;
                                        case constDefine.SITE_TYPE_UBEREATS:
                                            self.mediaLinks.linkUbereats = item.url;
                                            break;
                                        case constDefine.SITE_TYPE_FOODPANDA:
                                            self.mediaLinks.linkFoodpanda = item.url;
                                            break;
                                        case constDefine.SITE_TYPE_TIKTOK:
                                            self.mediaLinks.linkTiktok = item.url;
                                            break;
                                    }
                                }
                            )
                        } else {
                            self.mediaLinks.websiteStatus = false;
                            self.websites = '';
                        }
                    }

                    self.isDataProcessed = true;
                    //完畢
                    resolve();
                });
            },

            /** 將輪播圖轉成首頁輪播圖結構 */
            transToHomeBanner: function(photoItem) {
                if (this.$public.notNull(photoItem)) {
                    let newStruct = {
                        id: photoItem.id,
                        adParam: '',                //廣告參數
                        adType: 0,                  //廣告類型
                        imgUrl: photoItem.path,     //輪播圖
                        url: '',                    //點了以後要開啓的網頁
                    }
                    return newStruct;
                }
                return {};
            },

            /** 是否顯示輪播圖 */
            isShowBanner: function (banner) {
                return (this.$public.notNull(banner) && banner.length > 0)
            },

            /** 是否顯示"關於我們" */
            isShowAbout: function (info) {
                return (this.$public.notNull(info.about) && info.about !== "")
            },

            /** 是否顯示單圖 */
            isShowGraphImage: function (info) {
                return (this.$public.notNull(info.graphImageUrl) && info.graphImageUrl !== '')
            },

            /** 替換影片 url */
            changeVideoUrl: function (url) {
                //替換 i-frame 的連結
                // let watchKey = 'watch?v=';
                // let video = 'https://www.youtube.com/embed/69arSuOXsRE?controls=0';
                // this.videoUrl = 'https://www.youtube.com/watch?v=v_RT8hLUDuo';
                // this.videoUrl = '<iframe width="560" height="315" src="'+ video +'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"/>';

                if (this.$public.notNull(url) && url !== "") {
                    this.videoUrl = this.$public.getEmbedVideoUrl(url);
                    let frame = document.getElementById('intro-video-frame');
                    if (this.$public.notNull(frame)) {
                        frame.src = this.videoUrl;
                    }
                }
            },

            /** 是否顯示影片 url */
            isShowVideo: function (videoUrl) {
                return (this.$public.notNull(videoUrl) && videoUrl !== "")
            },

            /** 開啓 url */
            onLinkClick: function (url) {
                let isCordova = !!window.cordova;
                if (isCordova) {
                    //開啓頁面
                    this.$public.openUrl(url);
                } else {
                    window.open(url);
                }
            },

            handleAboutUs: function () {
                let self = this;

                self.$nextTick(() => {
                    Form.process(self.$refs.htmlAboutContainer)
                })
            },
        }
    }
</script>
<!--<style lang="less" scoped src="../../../less/store.less"/>-->
